import React from "react";
import ProductItem from "../../shared/components/product-item";
import { getProducts } from "../../services/Api";
import { useSearchParams } from "react-router-dom";
import Pagination from "../../shared/components/pagination";

const Search = () => {
    const [products, setProducts]=React.useState([]);
    const [pages, setPages]=React.useState({});
    const [searchParams, setSearchParams]= useSearchParams();
    const keyword = searchParams.get("keyword");//dua vao config
    const page = Number(searchParams.get("page")) || 1;
    // setSearchParams({
    //     name: "VietPro",
    //     email: "vietpro@gmail.com"
    // });
    React.useEffect(()=>{
        getProducts({
            params:{ 
                name: keyword,
                limit: 6,
                page,
            }
        }).then(({data})=>{ 
            setProducts(data.data.docs);
            setPages(data.data.pages);
        });
    },[keyword, page])
    return (
        <>
            <div>
                {/*	List Product	*/}
                <div className="products">
                    <div id="search-result">Kết quả tìm kiếm với sản phẩm <span>{keyword}</span></div>
                    <div className="product-list card-deck">
                        {
                            products?.map((product, index)=>{
                                return(
                                    <ProductItem key={index} item={product} />
                                )
                            })
                        }
                    </div>
                </div>
                {/*	End List Product	*/}
                {/*	pagination	*/}
                <Pagination pages={pages}/>
            </div>
        </>
    )
}
export default Search;